/* eslint-disable jsx-a11y/no-autofocus */
import { UserOutlined } from '@ant-design/icons/lib'
import { Divider, Row } from 'antd'
import KSearch from 'app/components/Modules/KSearch'
import KList from 'app/components/Modules/List/KList'
import KListItem from 'app/components/Modules/List/KListItem'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { useIndex } from 'app/lib/hooks/useApi'
import { useMutation } from 'app/lib/hooks/useMutation'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import * as rentalsCheckout from 'app/queries/Rentals/Checkout'
import React, { useEffect, useState } from 'react'

import { MemberProps } from '../../convention'

interface Props {
  onSuccess?: () => void
}

const ManagerContact: React.FC<MemberProps<IRental, Props>> = ({
  member: rental,
  props: { onSuccess } = {}
}) => {
  const {
    loading,
    execute,
    response: { data }
  } = useIndex<IContact>(RecordType.contact)
  const { loading: updating, execute: update } = useMutation(
    rentalsCheckout.UPDATE_MANAGER_CONTACT,
    {
      recordType: RecordTypeEnum.rental,
      silentSuccess: true
    }
  )
  const [q, setQ] = useState<string>(null)
  const { tRecordType } = useTranslation({ recordType: RecordTypeEnum.rental })

  useEffect(() => {
    execute({ filters: { roles: ['admin', 'manager'] }, sort: 'first_name' })
  }, [])

  useEffect(() => {
    if (q !== null) {
      execute({ q, filters: { roles: ['admin', 'manager'] }, sort: 'first_name' })
    }
  }, [q])

  const onSelect = async (manager: IContact) => {
    await update({ rentalId: rental?.id, managerContactId: manager.id })
    onSuccess?.()
  }

  const onItemClick = (item: IContact) => onSelect(item)

  const renderItem = (item: IContact, onClick?: (item: IContact) => void) => (
    <KListItem
      onClick={onClick ? () => onClick(item) : undefined}
      avatar={<UserOutlined className="font-size-22" />}
      title={item.name}
      verticalAlign
      description={item.email}
    />
  )

  return (
    <Row>
      <KCol span={24}>
        <Row gutter={[0, 12]} className="mobile-spacing">
          <KCol span={24}>
            <KSearch
              loading={loading}
              recordType={RecordType.manager_contact}
              onSearch={setQ}
              autoFocus
              showLabel
            />
          </KCol>
          <If condition={rental?.managerContact}>
            <KCol span={24}>
              <span>{tRecordType({ id: 'existing_manager_contact' })}</span>
            </KCol>
            <KCol span={24}>
              <Divider className="my-0" />
              <KList
                pagination={false}
                showTotal={false}
                dataSource={[rental.managerContact]}
                renderItem={(item) => renderItem(item, onItemClick)}
              />
              <Divider className="my-0" />
            </KCol>
            <KCol span={24} />
          </If>
          <KCol span={24}>
            <span>{tRecordType({ id: 'manager_contact' })}</span>
          </KCol>
          <KCol span={24}>
            <Divider className="my-0" />
            <KList
              pagination={false}
              showTotal={false}
              dataSource={data}
              loading={loading || updating}
              renderItem={(item) => renderItem(item, onItemClick)}
            />
            <Divider className="my-0" />
          </KCol>
        </Row>
      </KCol>
    </Row>
  )
}

export default ManagerContact
